import React, {useEffect} from 'react';
import Logo from '../UI/Logo/Logo';
import Button from '../UI/Button/Button';
import classes from './Url.module.scss';
import {updateContentStatus, postEvent} from '../../utils/helpers';

const Url = (props) => {
    const content = props.content;
    const device = props.device;

    const handleClickThrough = (url, target = '_blank') => {
        
        const event = {
            category: "end-user-action",
            subcategory: "content-button",
            action: "click-through",
            label: url,
        } 

        event.client_id = content?.client_id ?? null;
        event.campaign_id = content?.pivot?.campaign_id ?? null;
        event.trigger_id = content?.pivot?.trigger_id ?? null;
        event.content_id = content?.pivot?.content_id ?? null;

        updateContentStatus(content, 8, device);
        postEvent(device, event);
        window.open(url, target);

    }

    const createMarkup = (richText) => {
        return {__html : richText}
    }

    useEffect(() => {
        // Track view impression on load
        if(!content.scratcher?.enabled) {
            updateContentStatus(content, 1, device);
        };
        
    }, [])

    return (
        <div>
            <div style={{paddingTop: "10px", paddingBottom: "10px", textAlign: "center"}}>
                <Logo />{/* This next logo will get replaced with hero */}
            </div>
            <div style={{paddingTop: "15px", width: "100%", textAlign: "center", fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY}}> 
                <div style={{
                        color: "black", 
                        backgroundColor: "white", 
                        width: "88%", 
                        marginLeft: "auto", 
                        marginRight: "auto", 
                        height: "auto",
                        display: "block",
                        borderRadius: "8px",
                        paddingBottom: "10px"
                    }}>
                    <div>
                        <img alt="Content Hero" src={content.images?.hero?.url} style={{width: "100%", borderTopLeftRadius: "8px", borderTopRightRadius: "8px"}} />
                        <h1 style={{
                          width: "90%",
                          marginLeft: "auto",
                          marginRight: "auto",
                          color: process.env.REACT_APP_CONTENTSTYLE_TITLE_COLOR,
                          fontFamily: process.env.REACT_APP_CONTENT_URL_STYLE_TITLE_FONT_FAMILY,
                          fontSize: process.env.REACT_APP_CONTENT_URL_STYLE_TITLE_FONT_SIZE,
                          fontWeight: process.env.REACT_APP_CONTENT_URL_STYLE_TITLE_FONT_WEIGHT,
                          letterSpacing: 0,
                          lineHeight: process.env.REACT_APP_CONTENT_URL_STYLE_TITLE_LINE_HEIGHT,
                          textAlign: "center"
                        }}>{content.display_name}</h1>                        
                        <div style={{
                              height: "auto",
                              padding: "20px",
                              fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
                              fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
                              color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR,                              
                              fontWeight: "500",
                              letterSpacing: "0",
                              lineHeight: "26px",
                        }} dangerouslySetInnerHTML={createMarkup(content.description)}></div>
                    </div>
                    
                    <div style={{width: "90%", marginLeft: "auto", marginRight: "auto", paddingTop: "20px", paddingBottom: "20px"}}>
                        {content.url && 
                            <Button         
                                className={classes.Button} 
                                href={content?.url} 
                                target="_blank"
                                onClick={() => handleClickThrough(content?.url)}
                                btnText="Click Here"
                            />                        
                        }
                        {content?.urls?.map((url) => 
                            <Button 
                                className={classes.Button} 
                                href={url.url} 
                                key={url.url}
                                target={url.target?? '_self'}
                                onClick={() => handleClickThrough(url.url, url.target?? '_self')}
                                btnText={url.label}
                                style={url.style}
                                />
                        )}

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Url;
